import React from "react";
import { useTranslation } from "react-i18next";

import { DateTimeInput } from "@common/dateTimeInput";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function getDate(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
  );
}

function areDatesEqual(firstDate: Date, secondDate: Date): boolean {
  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  );
}

function Form({ date, milestoneEndDate, editDate }: Props) {
  const { t } = useTranslation();
  const now = new Date();
  const today = getDate(now);
  const currentDate = new Date(date);
  const endDate = getDate(new Date(milestoneEndDate));
  const isEndDateToday = areDatesEqual(today, endDate);
  const [isFreeDateChecked, setIsFreeDateChecked] = React.useState(false);

  return (
    <div className={styles.form}>
      <div
        className={styles.section}
        onClick={() => {
          editDate(today.toISOString());
          setIsFreeDateChecked(false);
        }}
      >
        <Checkbox
          isChecked={
            !isFreeDateChecked &&
            getDate(currentDate).toISOString() === today.toISOString()
          }
        />
        <p className={styles.label}>
          {t("milestoneCompletion.today")}{" "}
          {isEndDateToday ? `(${t("milestoneCompletion.endDate")})` : ""}
        </p>
      </div>
      {!!milestoneEndDate && !isEndDateToday && (
        <div
          className={styles.section}
          onClick={() => {
            editDate(endDate.toISOString());
            setIsFreeDateChecked(false);
          }}
        >
          <Checkbox
            isChecked={
              !isFreeDateChecked &&
              getDate(currentDate).toISOString() === endDate.toISOString()
            }
          />
          <p className={styles.label}>
            {t("milestoneCompletion.endDate")} ({endDate.toLocaleDateString()})
          </p>
        </div>
      )}
      <div className={styles.section}>
        <div
          className={styles.freeDateCheckBox}
          onClick={() => setIsFreeDateChecked(!isFreeDateChecked)}
        >
          <Checkbox isChecked={isFreeDateChecked} />
          <p className={styles.label}>{t("milestoneCompletion.anotherDate")}</p>
        </div>
        {isFreeDateChecked && (
          <DateTimeInput
            placeholder={t("milestoneCompletion.placeholder")}
            dateTime={date}
            input={editDate}
          />
        )}
      </div>
    </div>
  );
}

export { Form };
